import { Injectable } from '@angular/core';
import { ILoginPermissions } from '../models/interfaces/ILoginResponse';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserPermissions {
  private permissoesSubject = new BehaviorSubject<ILoginPermissions>(
    this.getPermissoes()
  );
  permissoes$ = this.permissoesSubject.asObservable();

  constructor() {
    window.addEventListener('storage', () => {
      this.permissoesSubject.next(this.getPermissoes());
    });
  }

  setPermissoes(permissoes: ILoginPermissions) {
    localStorage.setItem('userPermissions', JSON.stringify(permissoes));
    this.permissoesSubject.next(permissoes);
  }

  getPermissoes(): ILoginPermissions {
    const permissoesString = localStorage.getItem('userPermissions');
    return permissoesString
      ? JSON.parse(permissoesString)
      : {
          temAcessoMyVessel: false,
          temAcessoPortLineup: false,
          temAcessoPortSearch: false,
          temAcessoReports: false,
        };
  }
}
